/*
 * Copyright (c) 2019-2021 LogMeIn
 * All Rights Reserved Worldwide.
 *
 * THIS PROGRAM IS CONFIDENTIAL AND PROPRIETARY TO LOGMEIN
 * AND CONSTITUTES A VALUABLE TRADE SECRET.
 */

import React, { useState } from 'react';
import {
  CloseIcon,
  Flex,
  IconButton,
  Image,
  Text,
} from '@getgo/chameleon-chakra-ui';
import { defineMessages, useIntl } from 'react-intl';
import { Spacing } from '../../themes/GoToTheme';
import { colors } from '@getgo/chameleon-core';
import { BannerProps } from './AppBanner';
import { GoToLink } from '../Link/GoToLink';

const messages = defineMessages({
  ariaClose: {
    id: 'goto.mobile.banner.ariaClose',
  },
});

export const SmartBanner: React.FC<BannerProps> = ({
  author,
  buttonText,
  logo,
  price,
  storeText,
  title,
  link,
}) => {
  const { formatMessage: f } = useIntl();
  const [isVisible, showBanner] = useState(true);

  if (!isVisible) {
    return null;
  }

  return (
    <Flex
      justifyContent='space-between'
      bg={colors.neutrals.n100}
      margin={1}
      paddingY={2}
      alignItems='center'
    >
      <Flex alignItems='center'>
        <IconButton
          aria-label={f(messages.ariaClose)}
          icon={
            <CloseIcon
              width={Spacing.CoreLayout1}
              height={Spacing.CoreLayout1}
              color={colors.neutrals.n600}
            />
          }
          onClick={() => showBanner(false)}
          bg='none'
        />
        <Image src={logo} alt={title} objectFit='cover' height='54px' mr='3' />
        <Flex direction='column' mb={1} textColor={colors.neutrals.n700}>
          <Text fontSize='md' lineHeight='1.5' color={colors.neutrals.n500}>
            {title}
          </Text>
          <Text fontSize='sm' color={colors.neutrals.n500} lineHeight='1.1'>
            {author}
          </Text>
          <Text fontSize='sm' color={colors.neutrals.n500} lineHeight='1.1'>
            {price} - {storeText}
          </Text>
        </Flex>
      </Flex>
      <GoToLink mr={5} isExternal href={link} color='blue.500'>
        {buttonText}
      </GoToLink>
    </Flex>
  );
};
